import { Spin } from 'antd';

const Loading = () => (
  <div
    style={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Spin size="large" />
  </div>
);

export default Loading;
